<script>
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import {Link} from 'svelte-routing';
    import BottomMenu from '../components/BottomMenu.svelte';

    export let id;

    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    const fetchOrder = async () => {
        let data = await network.getOrder({id, user_kontr: +$user.idkontr});
    
        tv = data.order.tv;
        delivery = data.order.tipDost;
        idKontakt = data.order.idKontakt;
        nameKontakt = data.order.nameKontakt;
        telefonKontakt = data.order.telefonKontakt;
        adresKontakt = data.order.adresKontakt;
        other1Kontakt = data.order.other1Kontakt;
        other2Kontakt = data.order.other2Kontakt;
        
        return data;
    }
    let order = fetchOrder();
    
    const fetchChatMessagesCount = async () => {
        let buf = await network.getChatMessagesCount(id, +$user.id);
        return buf && buf[0] && buf[0].count ? +buf[0].count : 0;
    }
    let chat = fetchChatMessagesCount();
    
    
    let tv = '',
        delivery = '',
        idKontakt = '',
        nameKontakt = '',
        telefonKontakt = '',
        adresKontakt = '',
        other1Kontakt = '',
        other2Kontakt = ''
    ;
    
    const handlerChangeKontakt = async (e) => {
        let data = await order,
            value = e.target.value;
        
        if (data.kontakti.length && value) {
            let kontakt = data.kontakti.find((item) => item.nameKontakt === value);
            
            if (kontakt) {
                idKontakt = kontakt.idKontakt;
                telefonKontakt = kontakt.telefonKontakt;
                adresKontakt = kontakt.adresKontakt;
                other1Kontakt = kontakt.other1Kontakt;
                other2Kontakt = kontakt.other2Kontakt;
            }
        } else {
            idKontakt = '';
            telefonKontakt = '';
            adresKontakt = '';
            other1Kontakt = '';
            other2Kontakt = '';
        }
    }
    
    const handlerSaveContact = async () => {
        let data = await order;
        
        await network.saveKontakt({
            nom: id,
            vid: data.order.vid,
            idKontakt,
            nameKontakt,
            telefonKontakt,
            adresKontakt,
            other1Kontakt,
            other2Kontakt,
            actualnost: 1,
            user_kontr: +$user.idkontr,
        });

        let popup = new bootstrap.Modal(document.getElementById('modal-save'));
        popup.show();

        setTimeout(() => popup.hide(), 1500);
    }
    
    const handlerSaveDelivery = async () => {
        let data = await order;
        
        await network.saveDelivery({
            nom: id,
            vid: data.order.vid,
            tv: tv,
            dost: delivery,
        });

        let popup = new bootstrap.Modal(document.getElementById('modal-save'));
            popup.show();

        setTimeout(() => popup.hide(), 1500);
    }
    
    const handlerRemove = async () => {
        await network.saveKontakt({
            idKontakt,
            nameKontakt,
            telefonKontakt,
            adresKontakt,
            other1Kontakt,
            other2Kontakt,
            actualnost: 0,
            user_kontr: +$user.idkontr,
        });
    
        idKontakt = '';
        telefonKontakt = '';
        adresKontakt = '';
        other1Kontakt = '';
        other2Kontakt = '';
    }
</script>

<style>
    #contact .form-label {
        font-size: 12px;
        font-weight: normal;
    }
    #contact .btn.btn-icon.btn-outline-danger {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>

<TopMenu title="Детали заявки #{id}">
    <Link to="/dashboard" class="headerButton goBack" slot="left">
        <ion-icon name="chevron-back-outline" role="img" class="md hydrated" aria-label="chevron back outline"></ion-icon>
    </Link>
    <Link to="/chat/{id}" class="headerButton" slot="right">
        <ion-icon name="mail-outline" role="img" class="md hydrated" aria-label="mail outline"></ion-icon>
    
        {#await chat}...{:then count}
            {#if count}
                <span class="badge badge-danger">{count}</span>
            {/if}
        {/await}
    </Link>
</TopMenu>

<div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#info" role="tab" aria-selected="false">
                Информация
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#contact" role="tab" aria-selected="true">
                Контакт
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#delivery" role="tab" aria-selected="true">
                Доставка
            </a>
        </li>
    </ul>

</div>

<div id="appCapsule" class="extra-header-active">
    {#await order}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем информацию по вашей заявке..
                    </p>
                </div>
            </div>
        </div>
    {:then data}
        <div class="tab-content mt-2">
            <!-- info tab -->
            <div class="tab-pane fade active show" id="info" role="tabpanel">
                <ul class="listview">
                    <li>
                        <div class="in">
                            <div>
                                <header>Агрегат</header>
                                <b>{data.order.ind2}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>VIN номер</header>
                                <b>{data.order.vin}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Опись комплектующих</header>
                                <b>{data.order.opisanie}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Наименование агрегата</header>
                                <b>{data.order.name}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Описание проблемы</header>
                                <b>{data.order.komment}</b>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- * info tab -->
    
            <!-- contact tab -->
            <div class="tab-pane fade" id="contact" role="tabpanel">
                <ul class="listview mb-2">
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Контакт</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" list="kontakt" on:input={handlerChangeKontakt} bind:value={nameKontakt}>
    
                                        {#if idKontakt}
                                            <div class="input-group-append">
                                                <button class="btn btn-icon btn-outline-danger" type="button" on:click={handlerRemove}>
                                                    <ion-icon name="trash-outline"></ion-icon>
                                                </button>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                    
                                <datalist id="kontakt">
                                    {#each data.kontakti as item}
                                        <option value="{item.nameKontakt}">{item.adresKontakt} {item.telefonKontakt}</option>
                                    {/each}
                                </datalist>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Телефон</label>
                                    <input type="text" class="form-control" bind:value={telefonKontakt}>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Электронная почта</label>
                                    <input type="text" class="form-control" bind:value={other1Kontakt}>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Адрес</label>
                                    <textarea maxlength="1000" class="form-control" bind:value={adresKontakt}></textarea>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Доп.инфо</label>
                                    <textarea maxlength="1000" class="form-control" bind:value={other2Kontakt}></textarea>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
    
                <div class="carousel-button-footer">
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-primary btn-lg btn-block" on:click={handlerSaveContact}>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- * contact tab -->
    
            <!-- delivery tab -->
            <div class="tab-pane fade" id="delivery" role="tabpanel">
                <ul class="listview mb-2">
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Точка приёма и выдачи</label>
                                <select class="form-control form-select" bind:value={tv}>
                                    {#each data.tv as item}
                                        <option value="{item.nameTV}">{item.nameTV}: {item.adresTV}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </li>
                </ul>
                
                <ul class="listview mb-2">
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Тип доставки</label>
                                <select class="form-control form-select" bind:value={delivery}>
                                    {#each ['Самостоятельно', 'Сторонний курьер', 'Доставка БашДизель'] as item}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </li>
                </ul>

                {#if data.order.vid === '16'}
                    <div class="carousel-button-footer">
                        <div class="row">
                            <div class="col-12">
                                <button type="button" class="btn btn-primary btn-lg btn-block" on:click={handlerSaveDelivery}>Сохранить</button>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
            <!-- * delivery tab -->
        </div>

        <div class="modal fade dialogbox" id="modal-save" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-icon text-success">
                        <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title">Сохранено</h5>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    {/await}
</div>

